import script from "./AddDeceasedParticipant.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDeceasedParticipant.vue?vue&type=script&setup=true&lang=js"

import "./AddDeceasedParticipant.vue?vue&type=style&index=0&id=1a8285b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8285b8"]])

export default __exports__